<script lang="ts" setup>
import type {MenuItemRoute} from "~~/route/interface/menu-item-route.interface";
import {menuMainItems} from "~~/route/route.config";
import {EnvelopeOpenIcon, PhoneIcon, MapPinIcon, ArrowRightIcon} from "@heroicons/vue/20/solid";

const {collectionUri, pageUri} = useI18nCollection();
const {locale, t} = useI18n();
const config = useRuntimeConfig().public
const contact = await queryCollection(collectionUri('home')).path(pageUri('home/contact')).first();
const navItems: MenuItemRoute[] = menuMainItems.filter(i => i?.level1);
const contactInfo = config.contact;
/*
const currentYear = new Date().getFullYear();
const siteName = config.siteName;
const socials: Record<string, string | { url: string, human: string }> = config.socials;µ
*/
</script>

<template>
  <MediaInstagramFeed wrapper-class="max-w-7xl mx-auto px-3" />
  <footer class="bg-brand pt-16 pb-16 tablet:pb-0 rounded-img relative z-1 text-light">
    <div class="container tablet:flex flex-wrap items-stretch justify-between gap-6 laptop:gap-0">
      <div class="mb-4 tablet:w-full laptop:w-1/3 laptop:pe-6">
        <h4 class="section-title text-light mb-6">
          {{ contact.title }}
        </h4>
        <ContentRenderer :value="contact" class="mb-8 text-lg tablet:text-2xl font-medium with-free-text"/>
        <ButtonCta
                v-if="contact?.meta?.cta"
                :cta="contact.meta.cta"
                class="btn-border-green"
        >
          <template #icon-end>
            <ArrowRightIcon class="size-10 ms-2"/>
          </template>
        </ButtonCta>
      </div>
      <div class="tablet:w-full laptop:w-2/3 tablet:flex tablet:justify-between table:items-stretch gap-6">
        <ul class="text-center tablet:text-start bg-secondary-dark px-6 py-12 rounded-img tablet:mb-10 tablet:w-1/2 h-full tablet:max-w-70 laptop:ms-[5vw]">
          <li
                  v-for="item in navItems"
                  :key="item.identifier"
                  :class="{'mb-6': item.identifier === 'projects'}"
                  class="mb-2"
          >
            <a
              v-if="item.url" :href="item.url"
              class="transition-colors font-medium text-white hover:text-light text-lg block">
              {{ t(`nav.${item.identifier}`) }}
            </a>
            <NuxtLink
                    v-else-if="item.path"
                    :to="item.path[locale]"
                    class="transition-colors font-medium text-white hover:text-light text-lg block"
            >
              {{ t(`nav.${item.identifier}`) }}
            </NuxtLink>
          </li>
        </ul>

        <ul class="bg-secondary-alt py-12 px-6 rounded-img tablet:w-1/2 h-full">
          <li v-for="[key, uri] of Object.entries(contactInfo)" :key="key" class="flex items-center gap-6 mb-6">
            <div class="w-10">
              <EnvelopeOpenIcon v-if="key === 'email'" class="size-10 opacity-50 "/>
              <PhoneIcon v-if="key === 'phone'" class="size-10  opacity-50"/>
              <MapPinIcon v-if="key === 'address'" class="size-10  opacity-50"/>
            </div>
            <div>
              <a v-if="key === 'email'" :href="`mailto:${uri}`" class="text-brand-light hover:text-white">
                {{ uri }}
              </a>

              <a v-if="key === 'phone'" :href="`tel:${uri}`" class="text-brand-light hover:text-white">
                {{ uri }}
              </a>

              <a
                v-if="key === 'address'" :href="uri.url"
                class="text-brand-light hover:text-white">
                {{ uri.human }}
              </a>
            </div>
          </li>
        </ul>
      </div>
      <SiteLinks />
    </div>
  </footer>
</template>